class Step {
  constructor(name, completedURL, pendingURL) {
    this._name = name;
    this._completedURL = completedURL;
    this._pendingURL = pendingURL ?? completedURL;
  }

  get name() {
    return this._name;
  }

  get completedURL() {
    return this._completedURL;
  }

  get pendingURL() {
    return this._pendingURL;
  }
}

export default Step;
